export default __webpack_public_path__ + "static/media/Square-new.261b4ea7.png";